import { render, staticRenderFns } from "./Workstation.vue?vue&type=template&id=df784928"
import script from "./Workstation.vue?vue&type=script&lang=js"
export * from "./Workstation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports